var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObjectiveC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 125",
    d: "M0 0h65v65H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1186",
    d: "M54.827 22.5a4.357 4.357 0 0 0-.536-2.19 4.187 4.187 0 0 0-1.586-1.546q-8.752-5.056-17.505-10.1a4.3 4.3 0 0 0-4.658.046c-2.326 1.371-13.953 8.039-17.418 10.048A4.052 4.052 0 0 0 11 22.5v20.312a4.378 4.378 0 0 0 .512 2.149 4.173 4.173 0 0 0 1.61 1.588c3.465 2.009 15.094 8.677 17.416 10.051a4.3 4.3 0 0 0 4.659.046q8.75-5.057 17.51-10.1a4.174 4.174 0 0 0 1.61-1.588 4.383 4.383 0 0 0 .512-2.149V22.495",
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1188",
    d: "m37.444 29.566 6.821.048a10.746 10.746 0 0 0-11.125-9.801c-5.254 0-12.318 3.341-12.318 12.945s6.929 12.736 12.318 12.736c8.734 0 10.822-6.044 10.822-9.46l-6.511-.372s.174 3.951-4.35 3.951c-4.176 0-4.873-5.115-4.873-6.855 0-2.645.94-6.89 4.873-6.89a4.218 4.218 0 0 1 4.338 3.7",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectiveC);
export default __webpack_public_path__ + "static/media/objective-c.c6e648861aa163c4f4447406bf9b7f6b.svg";
export { ForwardRef as ReactComponent };